{
  "it": {
    "baseChip": {
      "states": {
        "included": "incluso",
        "excluded": "escluso"
      },
      "sortHint": "Usa i tasti freccia per spostare"
    }
  }
}
